// F.6 §6 — transformación de SOLO presentación para enums guardados en
// snake_case/minúsculas (estado_permisos, frecuencia_reporte, etc.). El
// backend sigue guardando el valor original tal cual; esto nunca se envía
// de vuelta al servidor.
export function capitalizarDisplay(valor: string): string {
  const texto = valor.replace(/_/g, ' ');
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}
